import { MenuItem } from '@chakra-ui/react';
import { AxiosError } from 'axios';
import { useGlobalContext } from 'GlobalContext';
import { toast } from 'react-toastify';
import { removeContract } from 'services/contract';
import { Mixpanel } from 'services/mixpanel';
import { AlertButtonOutput } from 'shared/components/Alert';
import { useFinancialContext } from '../../FinancialContext';

interface DeleteContractMenuItemProps {
  contractId?: number;
  icon?: JSX.Element;
  color?: string;
}
const DeleteContractMenuItem = ({
  icon,
  color,
  contractId,
}: DeleteContractMenuItemProps) => {
  const { alertController } = useGlobalContext();
  const { displayedContract, reloadContracts } = useFinancialContext();
  const deleteAlertButton = 'Sim, quero excluir';
  const changeAlertButtonState = (
    stt: boolean,
    alertButtonOutput: AlertButtonOutput,
  ) => {
    alertButtonOutput.clickedButton.disabled = stt;
    alertButtonOutput.clickedButton.text = stt
      ? 'Deletando...'
      : deleteAlertButton;
    alertButtonOutput.atualizeStateButton(alertButtonOutput.clickedButton);
  };
  const deleteContractRequest = (alertButtonOutput: AlertButtonOutput) => {
    changeAlertButtonState(true, alertButtonOutput);
    Mixpanel.track('customers-financial-deleted-contract');
    if (displayedContract?.id || contractId) {
      removeContract(displayedContract?.id || contractId!)
        .then(() => {
          changeAlertButtonState(false, alertButtonOutput);
          alertButtonOutput.close();
          toast.success('Contrato apagado com sucesso');
          reloadContracts(true);
        })
        .catch((e: AxiosError) => {
          changeAlertButtonState(false, alertButtonOutput);
          alertButtonOutput.close();
          toast.error('Não foi possível apagar o contrato');
          console.error(
            'Não foi possível apagar o contrato',
            e?.response?.data
              ? JSON.stringify(e?.response?.data, null, 2)
              : JSON.stringify(e?.response, null, 2),
          );
        });
    }
  };
  const confirmAction = (
    onConfirm: (alertButtonOutput: AlertButtonOutput) => void,
  ) => {
    alertController?.showAlert({
      title: 'Você tem certeza que quer cancelar o contrato?',
      message: 'O cliente vai perder as informações abaixo:',
      itensList: ['Serviços do contrato.', 'Histórico de cobranças.'],
      buttons: [
        {
          text: deleteAlertButton,
          variant: 'emphasisDanger',
          preventClose: true,
          onClick: (alertButtonOutput) => onConfirm(alertButtonOutput),
        },
        {
          text: 'Cancelar',
          variant: 'regular',
        },
      ],
    });
  };
  const handleMenuItemClick = () => {
    confirmAction(deleteContractRequest);
  };
  return (
    <MenuItem color={color} onClick={handleMenuItemClick} gap="2">
      {icon} Cancelar contrato
    </MenuItem>
  );
};
export default DeleteContractMenuItem;
